import { get, post } from '@/utils/request'

const cardProApi = {
  /* 卡密业务-商品管理，获取所有（在需要选择卡密业务商品的地方可以使用） */
  getAll: function () {
    return get('/card/product/list-all')
  },
  /* 卡密业务-商品管理-批量操作 */
  batchDeal: function (params) {
    return post('/card/product/batch', {
      productIds: params.productIds,
      operateType: params.operateType,
      effectiveType: params.effectiveType,
      effectiveTime: params.effectiveTime
    })
  },
  /* 关联直充商品 */
  relationPro: function (params) {
    return post('/card/product/cognate', {
      cardProductId: params.cardProductId,
      rechargeProductId: params.rechargeProductId,
      upstreamMemberId: params.upstreamMemberId,
      status: params.status
    })
  },
  /* 卡密业务-商品管理-添加或编辑（如果是编辑则需要传ID参数） */
  saveForm: function (params) {
    return post('/card/product/save-update', {
      id: params.id,
      cardProductTypeId: params.cardProductTypeId,
      productName: params.productName,
      businessType: params.businessType,
      faceValue: params.faceValue,
      price1: params.price1,
      price2: params.price2,
      price3: params.price3,
      price4: params.price4,
      price5: params.price5,
      price6: params.price6,
      price7: params.price7,
      price8: params.price8,
      productStatus: params.productStatus,
      consumeOrder: params.consumeOrder,
      provinceCode: params.provinceCode
    })
  },
  /* 卡密业务-商品管理-添加或编辑初始化（如果是编辑则需要传ID参数，会根据ID返回相应信息, 编号只显示，不能添加和编辑。如果是添加操作也可以不请求该接口方法。查看信息也可以使用该接口方法） */
  getInit: function (id) {
    return get('/card/product/save-update-init', { id })
  },
  /* 卡密业务-商品管理_修改状态 */
  updateStates: function (params) {
    return post('/card/product/update-status', {
      id: params.id,
      productStatus: params.productStatus
    })
  },
  /* 卡密业务-商品管理，获取库存数 */
  getStockCountById: function (id) {
    return get('/card/product/stock/' + id)
  }
}
export default cardProApi



// WEBPACK FOOTER //
// ./src/api/cardPro.js